import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";

const sendCode = credentials => {
    let url = apiUrlWithLang('/dashboard/api/login/send_code');
    return axios.post(url, credentials)
}

const authByCode = credentials => {
    let url = apiUrlWithLang('/dashboard/api/login')
    return axios.post(url, credentials)
}

const logout = () => {
    let url = apiUrlWithLang('/dashboard/api/logout')
    return axios.get(url)
}

const authByEmail = credentials => {
    let url = apiUrlWithLang('/dashboard/api/login/email')
    return axios.post(url, credentials)
}

const getUser = () => {
    let url = apiUrlWithLang('/dashboard/api/user')
    return axios.get(url)
}

const updateUser = credentials => {
    let url = apiUrlWithLang('/dashboard/api/user/update')
    return axios.post(url, credentials)
}

const setPasswordUser = credentials => {
    let url = apiUrlWithLang('/dashboard/api/user/password/update')
    return axios.post(url, credentials)
}

const sendVerifyMailLink = credentials => {
    let url = apiUrlWithLang('/dashboard/api/login/email/send_verify_mail_link')
    return axios.post(url, credentials)
}

const verificationEmail = credentials => {
    let url = apiUrlWithLang('/dashboard/api/login/email/verification_email')
    return axios.post(url, credentials)
}

export default {
    sendCode,
    authByCode,
    getUser,
    updateUser,
    setPasswordUser,
    sendVerifyMailLink,
    verificationEmail,
    authByEmail,
    logout
}